import React, { Component }          from 'react';
import ReactDOM                      from 'react-dom';
import { TimelineMax, Power4 }       from 'gsap';

import { Panel }                     from 'components/panel';
import Icon                          from 'components/icon';
import color                         from 'components/color';

class App extends Component {
  
  componentDidMount(){
    
    let panel                     =   ReactDOM.findDOMNode(this.refs.panel);    
    let logo                      =   ReactDOM.findDOMNode(this.refs.logo);    
    let panelCornerTopLeft        =   ReactDOM.findDOMNode(this.refs.panelCornerTopLeft);    
    let panelCornerTopRight       =   ReactDOM.findDOMNode(this.refs.panelCornerTopRight);    
    let panelCornerBottomLeft     =   ReactDOM.findDOMNode(this.refs.panelCornerBottomLeft);    
    let panelCornerBottomRight    =   ReactDOM.findDOMNode(this.refs.panelCornerBottomRight);    
    let toggle                    =   ReactDOM.findDOMNode(this.refs.toggle);    
    
    let timeline                  =   new TimelineMax({
      paused: true,
    }); 

    timeline.to(logo, 1.3, {
      opacity         : 1, 
      ease            : Power4.easeIn,
    }, 0);
    timeline.to(panelCornerTopLeft, 1.3, {
      opacity         : 1, 
      ease            : Power4.easeIn,
    }, 1);
    timeline.to(panelCornerBottomLeft, 1.3, {
      opacity         : 1, 
      ease            : Power4.easeIn,
    }, 1.5);
    timeline.to(panelCornerBottomRight, 1.3, {
      opacity         : 1, 
      ease            : Power4.easeIn,
    }, 2);
    timeline.to(panelCornerTopRight, 1.3, {
      opacity         : 1, 
      ease            : Power4.easeIn,
    }, 2.7);
    timeline.to(panel, 3, {
      backgroundColor : color.yellow, 
      ease            : Power4.easeIn,
    }, 3);   
    timeline.to(panel, 3, {
      color           : color.peach, 
      ease            : Power4.easeIn,
    }, 3);   
    timeline.to(panelCornerBottomRight, 3, {
      color           : color.peach, 
      ease            : Power4.easeIn,
    }, 3);          
    timeline.to(panel, 3, {
      backgroundColor : color.white, 
      ease            : Power4.easeIn,
    },6);   
    timeline.to(panel, 3, {
      color           : color.peach, 
      ease            : Power4.easeIn,
    }, 6);   
    timeline.to(panelCornerBottomRight, 3, {
      color           : color.peach, 
      ease            : Power4.easeIn,
    }, 6);            
    
    let timelineBackground      =   new TimelineMax({
      paused: true,
      repeat: true
    }); 
    
    timeline.play();
    
  }  
  
  render() {
    return (
      <div className="app">
        
        <Panel ref="panel">
          
          <Icon
            ref="logo" 
            icon="logo" 
            width="23.098958334vw"
            color={ color.peach } />
            
          <div className="panel-bottom-left" ref="panelCornerBottomLeft">
            Digital Agency | Strategy, Design & Technology. 
          </div>
          
          <div className="panel-top-left" ref="panelCornerTopLeft">
            A digital creative agency. Our passion is to create solutions and solve problems to allow our clients to communicate with customers, with collaborators and with the rest of the world. 
          </div>
          
          <div className="panel-top-right" ref="panelCornerTopRight">
            <div className="tel">Birmingham + London</div>
            
            {/* <div className="menu-toggle">
              <span ref="toggle"></span>
              <span ref="toggle"></span>
            </div> */}
            
          </div>
          
          
          <div className="panel-bottom-right">
            <a href="mailto:info@blemish.it">
              <Icon 
                ref="panelCornerBottomRight"
                icon="mail" 
                width="2.128205128vw"
                color={ color.white } />
            </a>
          </div>

        </Panel>
        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app.js